module.exports = __webpack_public_path__ + "static/img/mobile-01.c694cfe2.jpg";